(() => {
  const rememberProduct = () => {
    if (!document.body || !document.querySelector('main[data-template^="product"]')) return;
    const title = document.querySelector('h1')?.textContent?.trim();
    if (!title) return;
    let items = [];
    try { items = JSON.parse(localStorage.getItem('aa_recent_products') || '[]'); } catch(e) {}
    items = [{title, url: location.pathname}, ...items.filter(x => x.url !== location.pathname)].slice(0, 8);
    localStorage.setItem('aa_recent_products', JSON.stringify(items));
  };
  const updateCartCount = async () => {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      document.querySelectorAll('[data-aa-cart-count]').forEach(el => el.textContent = cart.item_count || '');
    } catch(e) {}
  };
  document.addEventListener('DOMContentLoaded', () => { rememberProduct(); updateCartCount(); });
  document.addEventListener('cart:update', updateCartCount);
})();